/* hs-eslint ignored failing-rules */

/* eslint-disable react/prop-types */
'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { List } from 'immutable';
import { NavMarker } from 'react-rhumb';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UITable from 'UIComponents/table/UITable';
import UICardWrapper from 'UIComponents/card/UICardWrapper';
import { RequestStatusRecord } from 'AdsUI/records/RequestStatus';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import THDragDrop from 'AdsUI/components/campaign-reporting/THDragDrop';
import { DraftSortColumns } from 'AdsUI/records/ad-management/DraftRecord';
import H5 from 'UIComponents/elements/headings/H5';
import DraftRow from './DraftRow';
const DRAFTS_TABLE_WIDTH = 4;

const DraftsZeroState = () => /*#__PURE__*/_jsx("tr", {
  children: /*#__PURE__*/_jsxs("td", {
    colSpan: 4,
    className: "text-center p-y-10",
    children: [/*#__PURE__*/_jsx(H5, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "campaigns.drafts.zeroState.header"
      })
    }), /*#__PURE__*/_jsx(FormattedMessage, {
      message: "campaigns.drafts.zeroState.message"
    })]
  })
});

const DraftsEmptyState = () => /*#__PURE__*/_jsx("tr", {
  children: /*#__PURE__*/_jsx("td", {
    colSpan: 4,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "campaigns.drafts.noDrafts"
    })
  })
});

const DraftsTable = ({
  drafts,
  hasAnyDrafts,
  adAccounts,
  canCreateMarketableContacts,
  requestStatus,
  sortKey,
  sortDirection,
  onSortChange,
  onDelete,
  onClick
}) => {
  const isLoading = !requestStatus || requestStatus.fetching;
  const isFailed = requestStatus && requestStatus.fetchFailed;
  return /*#__PURE__*/_jsx(UICardWrapper, {
    compact: true,
    children: /*#__PURE__*/_jsxs(UITable, {
      children: [/*#__PURE__*/_jsxs("colgroup", {
        children: [/*#__PURE__*/_jsx("col", {
          style: {
            width: '40%'
          }
        }), /*#__PURE__*/_jsx("col", {
          style: {
            width: '20%'
          }
        }), /*#__PURE__*/_jsx("col", {
          style: {
            width: '20%'
          }
        }), /*#__PURE__*/_jsx("col", {
          style: {
            width: '20%'
          }
        })]
      }), /*#__PURE__*/_jsx("thead", {
        children: /*#__PURE__*/_jsxs("tr", {
          children: [/*#__PURE__*/_jsx(THDragDrop, {
            editable: false,
            activeDirection: sortDirection,
            activeSortKey: sortKey,
            onSortChange: onSortChange,
            sortKey: DraftSortColumns.NAME,
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "campaigns.drafts.table.name"
            })
          }), /*#__PURE__*/_jsx(THDragDrop, {
            editable: false,
            activeDirection: sortDirection,
            activeSortKey: sortKey,
            onSortChange: onSortChange,
            sortKey: DraftSortColumns.TYPE,
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "campaigns.drafts.table.type"
            })
          }), /*#__PURE__*/_jsx(THDragDrop, {
            editable: false,
            activeDirection: sortDirection,
            activeSortKey: sortKey,
            onSortChange: onSortChange,
            sortKey: DraftSortColumns.AD_ACCOUNT,
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "campaigns.drafts.table.adAccount"
            })
          }), /*#__PURE__*/_jsx(THDragDrop, {
            editable: false,
            activeDirection: sortDirection,
            activeSortKey: sortKey,
            onSortChange: onSortChange,
            sortKey: DraftSortColumns.UPDATED_AT,
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "campaigns.drafts.table.lastUpdated"
            })
          })]
        })
      }), /*#__PURE__*/_jsx("tbody", {
        children: isLoading ? /*#__PURE__*/_jsx("tr", {
          children: /*#__PURE__*/_jsx("td", {
            colSpan: DRAFTS_TABLE_WIDTH,
            children: /*#__PURE__*/_jsx(UILoadingSpinner, {
              layout: "centered"
            })
          })
        }) : isFailed ? /*#__PURE__*/_jsx("tr", {
          children: /*#__PURE__*/_jsx("td", {
            colSpan: DRAFTS_TABLE_WIDTH,
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "campaigns.drafts.failed"
            })
          })
        }) : /*#__PURE__*/_jsx(NavMarker, {
          name: "DRAFTS_TABLE_LOADED",
          children: !hasAnyDrafts ? /*#__PURE__*/_jsx(DraftsZeroState, {}) : drafts.size === 0 ? /*#__PURE__*/_jsx(DraftsEmptyState, {}) : drafts.map(draft => /*#__PURE__*/_jsx(DraftRow, {
            draft: draft,
            adAccount: adAccounts.find(account => account.network === draft.adNetwork && account.accountId === draft.adAccountId),
            canCreateMarketableContacts: canCreateMarketableContacts,
            onClick: () => onClick(draft),
            onDelete: () => onDelete(draft)
          }, draft.id))
        })
      })]
    })
  });
};

DraftsTable.propTypes = {
  drafts: PropTypes.instanceOf(List).isRequired,
  adAccounts: PropTypes.instanceOf(List).isRequired,
  canCreateMarketableContacts: PropTypes.bool.isRequired,
  requestStatus: PropTypes.instanceOf(RequestStatusRecord),
  sortKey: PropTypes.string.isRequired,
  sortDirection: PropTypes.number.isRequired,
  onSortChange: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  hasAnyDrafts: PropTypes.bool.isRequired
};
export default DraftsTable;